import {IMaskedTextFieldProps, MaskedTextField} from "@fluentui/react";
import React from "react";
import {useErrorMessage} from "../hooks/useErrorMessage";

export const MaskedTextFieldWithError = (props: IMaskedTextFieldProps) => {
    const {localErrorMessage, clearLocalErrorMessage} = useErrorMessage(
        props.errorMessage,
    );

    return (
        <MaskedTextField
            {...props}
            errorMessage={localErrorMessage}
            onFocus={(e) => {
                clearLocalErrorMessage();
                props.onFocus?.(e);
            }}
        />
    );
};
